import {
  createAsyncThunk,
  createEntityAdapter,
  createSlice,
} from "@reduxjs/toolkit";
import { enqueueSnackbar } from "notistack";

import request from "../../utils/request";

// Create entity adapter
const testsAdapter = createEntityAdapter();

const initialState = testsAdapter.getInitialState({
  isLoading: false,
  page: 0,
  totalTests: 0,
  error: null,
});

// Async thunk for fetching all tests
export const getAllTests = createAsyncThunk(
  "tests/getAllTests",
  async (
    { page = 1, query = "", filter = null },
    { getState, rejectWithValue }
  ) => {
    try {
      const { auth } = getState();
      const company_id = auth.user?.company_id;

      const response = await request({
        url: "/assessment/test/get-all",
        method: "POST",
        data: { skip: page, take: 10, query, filter, company_id },
      });

      console.log("RESPONSE", response, page);

      return {
        page,
        count: response?.data?.count,
        data: response.data?.data,
      };
    } catch (error) {
      enqueueSnackbar(error?.message, {
        autoHideDuration: 3000,
        variant: "error",
      });
      return rejectWithValue(error?.message);
    }
  }
);

// Slice
const testsSlice = createSlice({
  name: "tests",
  initialState,
  extraReducers: (builder) => {
    builder
      .addCase(getAllTests.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(getAllTests.fulfilled, (state, action) => {
        state.isLoading = false;
        const { count, page, data } = action.payload;

        if (page === 1) {
          testsAdapter.setAll(state, data || []);
        } else if (data?.length > 0) {
          testsAdapter.upsertMany(state, data || []);
        }

        state.page = page;
        state.totalTests = count;
      })
      .addCase(getAllTests.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload || action.error.message;
      });
  },
});

// SELECTORS
export const {
  selectAll: selectAllTests,
  selectById: selectTestById,
  selectIds: selectTestsIds,
} = testsAdapter.getSelectors((state) => state.tests);

export const selectLoading = (state) => state.tests.isLoading;
export const selectPage = (state) => state.tests.page;
export const selectError = (state) => state.tests.error;

export default testsSlice.reducer;
